export default function createRef() {
  return {
    current: null
  };
}